import {
  ETipoDado,
  ETipoVisualizacao,
  EValidacaoNomeada
} from "./IntegracaoCampoEnum";
import {
  TIntegracaoAction,
  TIntegracaoActionPayloadTransform,
  TIntegracaoEndpointParameters,
  TIntegracaoRemoteCollection
} from "../services/CadastroDeIntegracaoGateway";

export type TIntegracaoCampoOpcao = {
  value: string;
  label: string;
  categoria?: string | null;
  attributes?: Record<string, unknown> | null;
};

export const SELECTED_OPTIONS_BY_FIELD_KEY = "__selectedOptionsByField";

export type TIntegracaoRegraExibicao = {
  nomeCampo: string;
  operador: string;
  valores: unknown[];
  visivelQuandoSatisfaz: boolean;
  origem?: "FieldValue" | "SelectedOptionAttribute";
  atributo?: string | null;
  agregacao?: "Any" | "All";
};

export type TIntegracaoCampoModel = {
  nomeCampo: string;
  label: string;
  tipo: ETipoDado;
  tipoVisualizacao: ETipoVisualizacao;
  obrigatorio: boolean;
  criptografado: boolean;
  mascara: string | null;
  descricao: string | null;
  placeholder: string | null;
  hint: string[];
  grupo: string;
  tamanho: number | null;
  fieldSize: string | null;
  ordem: number;
  valorPadrao: unknown;
  valorPersistido?: unknown[];
  hasPersistedValue?: boolean;
  visivel: boolean;
  desabilitado?: boolean;
  opcoes: TIntegracaoCampoOpcao[];
  regraExibicao: TIntegracaoRegraExibicao | null;
  regraObrigatoriedade?: TIntegracaoRegraExibicao | null;
  minLength?: number | null;
  validacaoNomeada: EValidacaoNomeada | null;
  endpoint: string | null;
  endpointParameters: TIntegracaoEndpointParameters | null;
  nomeObjetoNoLegado: string;
  payloadTransform: TIntegracaoActionPayloadTransform | null;
  includeInPayload: boolean;
  action: TIntegracaoAction | null;
  remoteCollection: TIntegracaoRemoteCollection | null;
  refetchDefinitionParameter?: string | null;
};

export type TIntegracaoCamposAgrupados = {
  grupo: string;
  campos: TIntegracaoCampoModel[];
}[];

export type TIntegracaoOpcoesSelecionadasPorCampo = Record<
  string,
  TIntegracaoCampoOpcao[]
>;
